/** 页面信息 */
const page = new (function () {
  this.title = '申请法院强制执行案件'
  this.icon = 'iconfont iconicon_group'
  this.name = 'penalize_query_qzxz'
  /**菜单编号 */
  this.code = 'penalize_query_qzxz'
  /**菜单别名 */
  this.aliasName = 'menu'
  /**路由地址 */
  this.path = '/query/qzxz'
  //**接口权限 */
  this.permissions = []
})()

/** 路由信息 */
export const route = {
  page,
  component: () => import('./index.vue')
}

export default page
